import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { CustomFamiliesConnector } from '../../conectors';
import { CustomFamiliesActionTypes, LoadFamilies, LoadFamiliesFail, LoadFamiliesSuccess } from '../actions/custom-families.action';

@Injectable()
export class CustomFamiliesEffects {
  constructor(private actions$: Actions, private familiesConnector: CustomFamiliesConnector) {}
  protected logger = inject(LoggerService);
  LoadFamilies$: Observable<LoadFamiliesSuccess | LoadFamiliesFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFamiliesActionTypes.LOAD_FAMILIES),
      map((action: LoadFamilies) => action.payload),
      exhaustMap((payload: { code: string; professional?: boolean }) =>
        this.familiesConnector.get(payload.code, payload.professional).pipe(
          map((families: any[]) => {
            return new LoadFamiliesSuccess(families);
          }),
          catchError((error) => of(new LoadFamiliesFail({ error: tryNormalizeHttpError(error, this.logger) })))
        )
      )
    )
  );
}

export const effectsFamilies: any[] = [CustomFamiliesEffects];
